/**
 * Deli condiments data
 * Represents condiments available by weight at the deli counter
 */

const deliCondiments = [
  {
    id: 1,
    name: "Homemade Russian Dressing",
    category: "condiments"
  },
  {
    id: 2,
    name: "Yellow Mustard",
    category: "condiments"
  },
  {
    id: 3,
    name: "Hot Mustard",
    category: "condiments"
  },
  {
    id: 4,
    name: "Honey Mustard",
    category: "condiments"
  },
  {
    id: 5,
    name: "Dijon Mustard",
    category: "condiments"
  },
  {
    id: 6,
    name: "Mayo",
    category: "condiments"
  },
  {
    id: 7,
    name: "Horseradish",
    category: "condiments"
  },
  {
    id: 8,
    name: "BBQ Sauce",
    category: "condiments"
  },
  {
    id: 9,
    name: "Ketchup",
    category: "condiments"
  },
  {
    id: 10,
    name: "Miracle Whip",
    category: "condiments"
  },
  {
    id: 11,
    name: "Ranch Dressing",
    category: "condiments"
  },
  {
    id: 12,
    name: "Italian Dressing",
    category: "condiments"
  }
];

module.exports = deliCondiments;